import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//UPDATE ACTION
export const editCustomerSegment = createAsyncThunk("editCustomerSegment", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`customer-segment/${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

//DELETE ACTION
export const deleteCustomerSegment = createAsyncThunk("deleteCustomerSegment", async ({ id }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.delete(`customer-segment/${id}`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CustomerSegmentEditSlice = createSlice({
	name: "CustomerSegmentEditSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(editCustomerSegment.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(editCustomerSegment.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(editCustomerSegment.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});

		builder.addCase(deleteCustomerSegment.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(deleteCustomerSegment.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(deleteCustomerSegment.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default CustomerSegmentEditSlice.reducer;
